/*
 * @Author: Alan
 * @Date: 2023-03-30 19:27:33
 * @LastEditors: Alan
 * @LastEditTime: 2023-04-26 09:00:04
 * @Description: 头部注释
 * @FilePath: \F1-M1-WEB-Code\components\Wallet\withdrawComponents\LBBankAccount\index.js
 */
import React from "react";
import { Select, Form, Icon } from "antd";
import ABankList from "$DATA/bank.static";
const { Item } = Form;
class LBBankAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {}
    render() {
        const {
            alreadyBindBanks,
            changeBankCard,
            goBankAccount,
            defaultBankCardId,
            isShowLBWithdrawalTip,
            isLBDescriptionCode,
            isBankUpgradingError,
        } = this.props;
        return (
            <React.Fragment>
                {console.log("this.props21", this.props)}
                <Item label="银行账户">
                    <div id="lbSelect" className={isBankUpgradingError ? 'has-error' : ''}>
                        <Select
                            size="large"
                            dropdownClassName="widthdraw-bank-card"
                            onChange={changeBankCard}
                            value={defaultBankCardId}
                            getPopupContainer={() =>
                                document.getElementById("lbSelect")
                            }
                            // 防止下拉框在滑动滚动条的时候不能同步
                        >
                            {alreadyBindBanks && alreadyBindBanks.length
                                ? alreadyBindBanks.map((item, index) => {
                                      let bankname = ABankList.find(
                                          (items) =>
                                              items.Name === item.bankName
                                      );
                                      let displayAccountNumber = item.accountNumber || '';
                                      if (displayAccountNumber) {
                                          if (displayAccountNumber.length>3) { // CXPC-489
                                              const hiddenLen = displayAccountNumber.length - 3;
                                              displayAccountNumber = Array(hiddenLen + 1).join('•') + displayAccountNumber.substring(hiddenLen)
                                          }
                                      }
                                      return (
                                          <Option key={item.iidd} value={index}>
                                              <img
                                                  style={{
                                                      width: 24,
                                                      height: 24,
                                                      marginRight: 10,
                                                  }}
                                                  src={`/cn/img/bank/${
                                                      bankname && bankname.Img
                                                          ? bankname.Img
                                                          : "generic"
                                                  }.png`}
                                              />
                                              {`${item.bankName} - ${displayAccountNumber}`}
                                              <Icon type="check" />
                                          </Option>
                                      );
                                  })
                                : null}
                            {alreadyBindBanks &&
                            alreadyBindBanks.length >= 5 ? null : (
                                <Option
                                    value={-1}
                                    className="withdrawal-new-bank"
                                    onClick={goBankAccount}
                                >
                                    {alreadyBindBanks &&
                                    alreadyBindBanks.length == 0
                                        ? "添加银行账户"
                                        : "新增银行卡"}
                                </Option>
                            )}
                        </Select>
                        {isBankUpgradingError && <div className="ant-form-explain">工商银行系统升级中 ; 请选择其他可用银行进行提款。</div>}
                    </div>
                </Item>
                {isShowLBWithdrawalTip !== "" &&
                    isLBDescriptionCode !== "P108102" && (
                        <div className="modal-prompt-info">
                            {isShowLBWithdrawalTip}
                        </div>
                    )}
                {isShowLBWithdrawalTip !== "" &&
                    isLBDescriptionCode == "P108102" && (
                        <div className="modal-prompt-info">
                            请注意:
                            ,该账户已到达提款限额,为了您的账户安全起见,建议您联系小同
                            <span
                                style={{ color: "#1C8EFF", cursor: "pointer" }}
                                onClick={() => global.PopUpLiveChat()}
                            >
                                在线客服
                            </span>
                            更新您的提款账户。
                        </div>
                    )}
            </React.Fragment>
        );
    }
}
export default Form.create({ name: "LBBankAccount" })(LBBankAccount);
